import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { initialPreview, reducePreview, type PreviewAction, type PreviewState } from './model';

export interface UsagePreviewController {
  state: PreviewState | null;
  enable: () => void;
  exit: () => void;
  dispatch: (action: PreviewAction) => void;
}
export const UsagePreviewContext = createContext<UsagePreviewController | null>(null);
export const useUsagePreview = () => useContext(UsagePreviewContext);

/** Local ephemeral UI only: no persistence, analytics, provider or billing services. */
export function useAdminUsagePreview(uid: string | null, tier: string): UsagePreviewController | null {
  const session = useRef(0);
  const [snapshot, setSnapshot] = useState<{ owner: string; session: number; state: PreviewState } | null>(null);
  useEffect(() => { setSnapshot(null); }, [uid, tier]);
  if (!uid || tier !== 'admin') return null;
  return {
    state: snapshot?.owner === uid ? snapshot.state : null,
    enable: () => setSnapshot({ owner: uid, session: ++session.current, state: initialPreview(Date.now()) }),
    exit: () => setSnapshot(null),
    dispatch: action => setSnapshot(current => current?.owner === uid && current.session === snapshot?.session
      ? { ...current, state: reducePreview(current.state, action) } : current)
  };
}
